import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CreditCardIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CreditCardIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 14">
      <path d="M3,8.75h6c0.41,0,0.75-0.34,0.75-0.75c0-0.41-0.34-0.75-0.75-0.75H3C2.59,7.25,2.25,7.59,2.25,8C2.25,8.41,2.59,8.75,3,8.75 z" />
      <path d="M3,10.75h3c0.41,0,0.75-0.34,0.75-0.75S6.41,9.25,6,9.25H3c-0.41,0-0.75,0.34-0.75,0.75S2.59,10.75,3,10.75z" />
      <path d="M18,0H2C0.9,0,0,0.9,0,2v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V2C20,0.9,19.1,0,18,0z M18.5,12c0,0.28-0.22,0.5-0.5,0.5H2 c-0.28,0-0.5-0.22-0.5-0.5V5.75h17V12z M18.5,4.25h-17v-0.5h17V4.25z M18.5,2.25h-17V2c0-0.28,0.22-0.5,0.5-0.5h16 c0.28,0,0.5,0.22,0.5,0.5V2.25z" />
    </Icon>
  )
}
export default CreditCardIcon
